(() => {
  if (typeof Splide === "undefined") return;

  const DEFAULT_PRODUCTS_PER_SLIDE = 4;
  const sectionId = document.currentScript.getAttribute("data-section-id");
  const productsPerSlide =
    parseInt(
      document.currentScript.getAttribute("data-products-per-slide"),
      10,
    ) || DEFAULT_PRODUCTS_PER_SLIDE;
  const splideElement = document.getElementById(`splide-${sectionId}`);
  const sectionEl = document.getElementById(`section-${sectionId}`);

  if (
    !splideElement ||
    !sectionEl ||
    splideElement.classList.contains("is-initialized")
  )
    return;

  const splide = new Splide(splideElement, {
    perPage: productsPerSlide,
    type: "loop",
    gap: "var(--space-2xs)",
    arrows: false,
    pagination: false,
    drag: true,
    snap: true,
    breakpoints: {
      768: {
        perPage: 2,
      },
      470: {
        perPage: 1,
      },
    },
  });

  splide.mount();

  sectionEl.querySelectorAll(".js-slider-prev").forEach((button) => {
    button.addEventListener("click", () => splide.go("<"));
  });

  sectionEl.querySelectorAll(".js-slider-next").forEach((button) => {
    button.addEventListener("click", () => splide.go(">"));
  });
})();
